import moment from "moment";
import { sensorThreshold } from "../core/reducers/data";

export const emptyValueHyphen = "-";
export const emptyValueNA = "NA";

export const autoRefreshRate = 60000;
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";


/**
 * Looks up the sensor rule from iaqLegendDetailsVM and maps
 * the color string to a CSS modifier: "good" | "moderate" | "unhealthy"
 */
export const getKPIThresholdRange = (name: string, value: number, getKPIThresholdRange?: any) => {
   if(getKPIThresholdRange === null) return null;
    const key = name.toUpperCase();

    const thresholdMap: Record<string, { t1: number; t2: number; maxLimit: number }> = {
        PMI_2_5: { t1: getKPIThresholdRange.PM_T1, t2: getKPIThresholdRange.PM_T2, maxLimit: 1000 },
        CO2: { t1: getKPIThresholdRange.CO2_T1, t2: getKPIThresholdRange.CO2_T2, maxLimit: 5000 },
        TVOC: { t1: getKPIThresholdRange.VOC_T1, t2: getKPIThresholdRange.VOC_T2, maxLimit: 2000 },
        CH2O: { t1: getKPIThresholdRange.CH2O_T1, t2: getKPIThresholdRange.CH2O_T2, maxLimit: 5000 },
        CO: { t1: getKPIThresholdRange.CO_T1, t2: getKPIThresholdRange.CO_T2, maxLimit: 20 },
    };

    const threshold = thresholdMap[key];
    if (!threshold) return null;

    const { t1, t2, maxLimit } = threshold;
    const valueToSubtract = key === "CO" ? 0.1 : 1;

    // Row 1: 0 <= value <= t1-1  → Green
    // Row 2: t1 <= value <= t2-1 → Yellow
    // Row 3: t2 <= value <= max  → Red
    if (value >= 0 && value <= t1 - valueToSubtract) return 'Green';
    if (value >= t1 && value <= t2 - valueToSubtract) return 'Yellow';
    if (value >= t2 && value <= maxLimit) return 'Red';

    return null;
};

export const getYAxisInterval = (min: number, max: number): number => {
    const range = max - min;
    const rawInterval = range / 5;
    const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval)));
    const interval = Math.ceil(rawInterval / magnitude) * magnitude;

    if (min % interval !== 0) {
      return Math.ceil(rawInterval / magnitude) * (magnitude / 2);
    }
    return interval;
};

export const chartTheme_Color = {
    CHART_BG: "#0d1117",
    CHART_LINE_COLOR: "#00e5ff",
    CHART_LINE_COLOR2: "#FFD54F",
    CHART_MARKER_COLOR: "#00e5ff",
    CHART_MARKER_COLOR2: "#FFD54F",
    AXIS_LABEL_COLOR: "#ffffff",
    TITLE_COLOR: "#ffffff",
    GRID_COLOR: "rgba(255,255,255,0.12)",
    AXIS_LINE_COLOR: "rgba(255,255,255,0.25)",
    TOOLTIP_BG: "#1e2a44",
}


/**
 * Converts a UTC date string to the user's local timezone.
 */
export const formatUtcToLocal = (date: string) => {
  if (!date) return null;

  return moment(new Date(`${date}Z`)).format(DATE_TIME_FORMAT);
};

/**
 * Returns the user's timezone offset in minutes.
 * Example: IST = -330, UTC = 0.
 */
export const getTZOffset = () => {
  return -new Date().getTimezoneOffset();
};

/**
 * Converts a local date-time string to UTC.
 */
export const convertLocalToUTC = (dateTime: string) => {
    if(!dateTime) return null
  return moment(dateTime).utc().format(DATE_TIME_FORMAT);
};